import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { getRecentNotification } from '../store/notifications/selectors/getRecentNotification';
import { recentNotificationSetAction } from '../store/notifications/actions/recentNotificationSetAction';

export const setRecentNotification = (
    recentNotification: number
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const currentRecentNotification = getRecentNotification(getState());
        if (!recentNotification || recentNotification === currentRecentNotification) return;
        $(document).find('.notification-group--recent')
            .removeClass('notification-group--recent');

        dispatch(recentNotificationSetAction(recentNotification))

        $(document).find(`[data-notificationid='${recentNotification}']`)
            .addClass('notification-group--recent');
    };
    return action;
};
